import { gql } from '@apollo/client';

export const FETCH_ENCODINGS = gql`
    query fetchEncodings {
        lookup {
            encodings {
                codePage
                name
                displayName
            }
        }
    }
`;
